@if (formControl) {
  <div class="input-group">
    <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
    <input
      type="text"
      [coreAutoHttps]="enableAutoHttps()"
      [formControl]="formControl"
      class="form-control form-control-solid"
      [placeholder]="placeholder()"
    />
  </div>
}
@if (!formControl) {
  <div class="input-group">
    <ng-container *ngTemplateOutlet="imageTemplate"></ng-container>
    <input
      type="text"
      class="form-control form-control-solid"
      [coreAutoHttps]="enableAutoHttps()"
      [placeholder]="placeholder()"
    />
  </div>
}

<ng-template #imageTemplate>
  <div class="btn btn-icon btn-primary pointer-events-none">
    @if (icon()) {
      <ui-keenicon class="fs-3" [name]="icon()"></ui-keenicon>
    }
    @if (image()) {
      <img [src]="image()" class="h-30px social-image" alt="social" />
    }
  </div>
</ng-template>

@if (formControl && !skipValidation() && control()!['touched']) {
  <ui-validation-form [control]="control()!"></ui-validation-form>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
